module.exports = __webpack_public_path__ + "img/quest_visualization_quest_pending_4.98a6f938.svg";